module.exports = function() {
  return new Worker(__webpack_public_path__ + "77624432cd6abfb6746e.worker.js");
};